// Componentes del módulo de ecommerce
const Ordernotes = () => import('@/components/ecommerce/Ordernotes.vue');
const OrderDetail = () => import('@/components/ecommerce/Detalle.vue');
const Catalogos = () => import('@/components/ecommerce/catalogos/Catalogs.vue');
const NuevoCatalogo = () => import('@/components/ecommerce/catalogos/Edit-catalog.vue');

const ecommerce = {
  path: '/ecommerce',
  redirect: { name: 'Pedidos Ecommerce' },
  children: [
    {
      path: '',
      name: 'Pedidos Ecommerce',
      component: Ordernotes,
      meta: { title: 'Pedidos de Tienda Online' },
    },
    {
      path: 'pedidos/:orderId',
      name: 'Pedido Ecommerce',
      component: OrderDetail,
      props: true,
      meta: { title: 'Detalle de Pedido' },
    },
    {
      path: 'catalogos',
      name: 'Catalogos',
      component: Catalogos,
      meta: { title: 'Catálogos' },
    },
    {
      path: 'catalogos/nuevo',
      name: 'Nuevo catalogo',
      component: NuevoCatalogo,
      meta: { title: 'Nuevo Catálogo' },
    },
    {
      path: 'catalogos/:sourceid/editar',
      name: 'Editar catalogo',
      component: NuevoCatalogo,
      props: true,
      meta: { title: 'Editar Catálogo' },
    },

  ],
};

export default ecommerce;
